import { render, staticRenderFns } from "./Hefeng.vue?vue&type=template&id=66a612c8&scoped=true&"
import script from "./Hefeng.vue?vue&type=script&lang=js&"
export * from "./Hefeng.vue?vue&type=script&lang=js&"
import style0 from "./Hefeng.vue?vue&type=style&index=0&id=66a612c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a612c8",
  null
  
)

export default component.exports